export const RESET_PASSWORD_HEADER_STRINGS = {
  platformName: 'Licensing Management Platform',
} as const
